import React, { FunctionComponent } from 'react'
import { Trans, useTranslation } from '../../utils/convergence'
import { TermLink } from '../TermLink'
import { Grid, Text, DesignLanguage, useIsDesignLanguage } from '@afterpaytouch/core'

export const Terms: FunctionComponent = () => {
  const { t } = useTranslation()
  const isArcadeDesignLanguage = useIsDesignLanguage(DesignLanguage.Arcade)
  const linkColor = isArcadeDesignLanguage ? 'Black' : 'Orca'

  const components = {
    terms: <TermLink key='verify-identity-passport-terms' href={t('common:termsOfServiceUrl')} color={linkColor} fontFace='CashSansMono' />,
    privacy: <TermLink key='verify-identity-passport-privacy' href={t('common:privacyPolicyUrl')} color={linkColor} fontFace='CashSansMono' />,
  }

  return (
    <Grid>
      <Text color='Gray40' size='XXS' fontFace='CashSansMono'>
        <Trans i18nKey='verifyIdentity:passport:terms' components={components} />
      </Text>
    </Grid>
  )
}
